export default __webpack_public_path__ + "static/media/arrow-up.9d3a86d6.svg";